import React, { useState } from "react";
import OpenRoleList from "./OpenRoleList";
import ProfileList from "./ProfileList";
import ActivationPromptPreviewWindow from "./ActivationPromptPreviewWindow";

const ActivateUserPopup = ({ user, interests, firstName, onClose }) => {
  const [mode, setMode] = useState("roles");
  const [allMatches, setAllMatches] = useState([]);
  const [previewCards, setPreviewCards] = useState([]);
  const [previewSource, setPreviewSource] = useState("");
  const [emailIntro, setEmailIntro] = useState("");
  const [emailOutro, setEmailOutro] = useState("");
  const [emailVisible, setEmailVisible] = useState(false);

  const handleActivate = async () => {
  const token = localStorage.getItem("token");
  const source = mode === "roles" ? "roles" : "profiles";
  const top3 = allMatches.slice(0, 3);

  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/codi/admin/activation-preview`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        source,
        email: user.email,
        matches: top3,
        firstName: user.firstName,
        interests: interests,
      }),
    });

    const data = await res.json();

    // ✅ Log full response
    console.log("🟩 [Activation Preview] Raw API Response:", data);

    const preview = data.preview || "⚠️ No email returned.";
    const intro = data.emailIntro?.trim() || "";
    const outro = data.emailOutro?.trim() || "";
    const cards = top3;

    // ✅ Log parsed values for UI
    console.log("📩 Parsed Email Intro:", intro);
    console.log("📬 Parsed Cards:", cards);
    console.log("🔚 Parsed Email Outro:", outro);

    setEmailIntro(intro);
    setEmailOutro(outro);
    setPreviewCards(cards);
    setPreviewSource(source);
    setEmailVisible(true);
  } catch (err) {
    console.error("❌ Activation preview error:", err);
  }
};


  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full relative max-h-[90vh] overflow-y-auto">
          <button
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            onClick={onClose}
          >
            ✖
          </button>

          <h2 className="text-lg font-semibold mb-2">Activate {user.firstName}</h2>
          <p className="text-sm text-gray-600 mb-4">
            You're about to send an activation prompt to{" "}
            <strong>{user.email}</strong>.
          </p>

          {/* Mode switch */}
          <div className="flex gap-2 mb-4">
            <button
              onClick={() => setMode("roles")}
              className={`px-3 py-1 text-sm rounded ${
                mode === "roles"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
            >
              🎯 Find Roles
            </button>
            <button
              onClick={() => setMode("people")}
              className={`px-3 py-1 text-sm rounded ${
                mode === "people"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
            >
              🧑‍🤝‍🧑 Find People
            </button>
          </div>

          {mode === "roles" ? (
            <OpenRoleList
              interests={interests}
              onTopMatches={(items) => setAllMatches(items)}
            />
          ) : (
            <ProfileList
              interests={interests}
              currentUser={user}
              onTopMatches={(items) => setAllMatches(items)}
            />
          )}

          <button
            onClick={handleActivate}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-medium w-full mt-4"
          >
            Send Activation Prompt
          </button>
        </div>
      </div>

      {emailVisible && (
        <ActivationPromptPreviewWindow
          cards={previewCards}
          source={previewSource}
          targetEmail={user.email}
          emailIntro={emailIntro}
          emailOutro={emailOutro}
          onClose={() => setEmailVisible(false)}
        />
      )}
    </>
  );
};

export default ActivateUserPopup;
